import { type PODisclaimerLabel } from '@webapp/modules/purchasing/entities/PODisclaimerLabel'
import { type PODisclaimerLabelEditableField } from '@webapp/modules/purchasing/features/edit-po-disclaimer-label/models'
import { EditablePODisclaimerLabelTextField } from '@webapp/modules/purchasing/features/edit-po-disclaimer-label/views/EditablePODisclaimerLabelTextField'
import { useEditablePODisclaimerLabelTextFieldPresenter } from './useEditablePODisclaimerLabelTextFieldPresenter'

export interface IEditablePODisclaimerLabelTextFieldPresenterProps {
  label: PODisclaimerLabel
  field: PODisclaimerLabelEditableField
  onSuccess?: () => void
}

export const EditablePODisclaimerLabelTextFieldPresenter = ({
  label,
  field,
  onSuccess,
}: IEditablePODisclaimerLabelTextFieldPresenterProps) => {
  const {
    data: { inputValue, status },
    handlers: { handleChange, handleCommit, handleEscape },
  } = useEditablePODisclaimerLabelTextFieldPresenter({
    label,
    field,
    onSuccess,
  })

  return (
    <EditablePODisclaimerLabelTextField
      value={inputValue}
      field={field}
      status={status}
      onChange={handleChange}
      onCommit={handleCommit}
      onEscape={handleEscape}
    />
  )
}

EditablePODisclaimerLabelTextFieldPresenter.displayName =
  'EditablePODisclaimerLabelTextFieldPresenter'
